import React from 'react';

class Footer extends React.Component{
    render(){
        return (
            <div className="footer">
                &copy; Sistem Informasi Uang Kuliah Tunggal. Dikembangkan oleh Universitas Negeri Jakarta.
            </div>
        );
    }
}

export default Footer;